import support from '../../assetss/img/storyImgOne.png'
import help from '../../assetss/img/storyImgToo.png'

export const newStory = [
  {
    src: support,
    title: 'I want to share what\'s troubling me and get support from others',
    rout: 'troubled',
    color: '#FE794E',
    type: 0,
  },
  {
    src: help,
    title: 'I want to share my life experience to help others',
    rout: 'empowered',
    type: 1,
  },
]
